module.exports = __webpack_public_path__ + "prod/1.42.2/img/font4.08a48abb.png";